const recoverCursorPos = (input, position) => {
  setTimeout(() => {
    input.selectionEnd = position;
  }, 1);
};

const charCounter = (text, char) => {
  let counter = 0;
  for (let i = 0; i < text.length; i++) {
    if (text[i] === char) {
      counter++;
    }
  }
  return counter;
};

export const formatField = (input, text, type, dontForceUppercase) => {
  let position = input.selectionStart;
  switch (type) {
    case "type-only-chars":
      text = text.replace(/[^a-zA-ZñÑ]/g, "");
      break;
    case "type-only-numbers":
      text = text.replace(/[^0-9]/g, "");
      break;
    case "type-positive-nonzero":
      text = text.replace(/[^0-9]/g, "");

      if (text.startsWith("0")) {
        text = text.substring(1);
      }
      break;
    case "type-only-positive-numbers":
      // Eliminar todo lo que no sea número
      text = text.replace(/[^0-9]/g, "");

      // Si hay más de un carácter y empieza por 0, quitar ceros iniciales
      if (text.length > 1 && text.startsWith("0")) {
        text = text.replace(/^0+/, "");
      }
      break;
    case "type-only-charnumbers":
      text = text.replace(/[^a-zA-Z0-9]/g, "");
      break;
    case "type-alpha":
      text = text.replace(
        /[^a-zA-ZñÑçÇáÁàÀâÂäÄéÉèÈêÊëËíÍìÌîÎïÏóÓòÒôÔöÖúÚùÙûÛüÜºª \.\-\,]/g,
        "",
      );
      break;
    case "type-alphanum":
      text = text.replace(
        /[^a-zA-ZñÑçÇáÁàÀâÂäÄéÉèÈêÊëËíÍìÌîÎïÏóÓòÒôÔöÖúÚùÙûÛüÜºª \.\-\,0-9]/g,
        "",
      );
      break;
    case "type-alpha-ext":
      text = text.replace(
        /[^a-zA-ZñÑçÇáÁàÀâÂäÄéÉèÈêÊëËíÍìÌîÎïÏóÓòÒôÔöÖúÚùÙûÛüÜºª\\\/\(\) \.\-\,]/g,
        "",
      );
      break;
    case "type-alphanum-ext":
      text = text.replace(
        /[^a-zA-ZñÑçÇáÁàÀâÂäÄéÉèÈêÊëËíÍìÌîÎïÏóÓòÒôÔöÖúÚùÙûÛüÜ&ºª\\\/\(\) \.\-\,0-9]/g,
        "",
      );
      break;
    case "type-alphanum-ext-2":
      text = text.replace(
        /[^a-zA-ZñÑçÇáÁàÀâÂäÄéÉèÈêÊëËíÍìÌîÎïÏóÓòÒôÔöÖúÚùÙûÛüÜ&ºª\\\/\(\) \.\-\,\+0-9\n]/g,
        "",
      );
      break;
    case "type-full":
      text = text.replace(/[^\s\S]/g, "");
      break;
    case "type-integer":
      text = text.replace(/[^\d-]/g, "");
      if (text[position - 1] === "-" && text.length > 1) {
        if (position - 1 > 0) {
          const token1 = text.substring(0, position - 1);
          const token2 = text.substring(position, text.length);
          text = token1 + token2;
        }
      }
      break;
    case "type-positive-integer":
      text = text.replace(/[^\d]/g, "");
      break;
    case "type-integer-min2":
      text = text.replace(/[^\d]/g, "");
      if (text.length > 0 && parseInt(text) < 2) text = text.slice(0, -1);
      break;
    case "type-float2":
    case "type-float":
      text = text.replace(".", ",");
      text = text.replace(/[^\d,-]/g, "");
      if (text[position - 1] === "-" && text.length > 1) {
        if (position - 1 > 0) {
          const token1 = text.substring(0, position - 1);
          const token2 = text.substring(position, text.length);
          text = token1 + token2;
        }
      }
      if (text[position - 1] === ",") {
        let counter = charCounter(text, ",");
        if (counter > 1) {
          const token1 = text.substring(0, position - 1);
          const token2 = text.substring(position, text.length);
          text = token1 + token2;
        }
      }
      break;
    case "type-positive-float":
      text = text.replace(".", ",");
      text = text.replace(/[^\d,]/g, "");
      if (text[position - 1] === "-" && text.length > 1) {
        if (position - 1 > 0) {
          const token1 = text.substring(0, position - 1);
          const token2 = text.substring(position, text.length);
          text = token1 + token2;
        }
      }
      if (text[position - 1] === ",") {
        let counter = charCounter(text, ",");
        if (counter > 1) {
          const token1 = text.substring(0, position - 1);
          const token2 = text.substring(position, text.length);
          text = token1 + token2;
        }
      }
      break;
    case "type-floatint":
      text = text.replace(".", ",");
      text = text.replace(/[^\d,-]/g, "");

      if (text.indexOf("-") > 0) {
        text = text.replace(/-/g, "");
        text = "-" + text;
      }

      if (text.startsWith("--")) {
        text = text.substring(1);
      }

      if (text[position - 1] === ",") {
        let counter = charCounter(text, ",");
        if (counter > 1) {
          const token1 = text.substring(0, position - 1);
          const token2 = text.substring(position, text.length);
          text = token1 + token2;
        }
      }
      break;
    case "type-positive-floatint":
      text = text.replace(".", ",");
      text = text.replace(/[^\d,]/g, "");

      if (text[position - 1] === "-" && text.length > 1) {
        if (position - 1 > 0) {
          const token1 = text.substring(0, position - 1);
          const token2 = text.substring(position, text.length);
          text = token1 + token2;
        }
      }
      if (text[position - 1] === ",") {
        let counter = charCounter(text, ",");
        if (counter > 1) {
          const token1 = text.substring(0, position - 1);
          const token2 = text.substring(position, text.length);
          text = token1 + token2;
        }
      }
      break;
    case "type-phone":
      text = text.replace(/[^0-9\+]/g, "");
      if (text[position - 1] === "+" && text.length > 1) {
        if (position - 1 > 0) {
          const token1 = text.substring(0, position - 1);
          const token2 = text.substring(position, text.length);
          text = token1 + token2;
        }
      }
      break;
    case "type-email":
      text = text.replace(/[^a-zA-Z\.\-\_@0-9]/g, "");
      if (text[position - 1] === "@") {
        let counter = charCounter(text, "@");
        if (counter > 1) {
          const token1 = text.substring(0, position - 1);
          const token2 = text.substring(position, text.length);
          text = token1 + token2;
        }
      }
      break;
    case "type-cp":
      text = text.replace(/[^0-9]/g, "").substring(0, 5);
      break;
    case "type-optofloat":
      text = text.replace(".", ",");
      text = text.replace(/[^\d,\+-]/g, "");
      if (text[position - 1] === "-" && text.length > 1) {
        if (position - 1 > 0) {
          const token1 = text.substring(0, position - 1);
          const token2 = text.substring(position, text.length);
          text = token1 + token2;
        }
      }
      if (text[position - 1] === "+" && text.length > 1) {
        if (position - 1 > 0) {
          const token1 = text.substring(0, position - 1);
          const token2 = text.substring(position, text.length);
          text = token1 + token2;
        }
      }
      if (text[position - 1] === ",") {
        let counter = charCounter(text, ",");
        if (counter > 1) {
          const token1 = text.substring(0, position - 1);
          const token2 = text.substring(position, text.length);
          text = token1 + token2;
        }
      }
      break;
    case "type-positive-optofloat":
      text = text.replace(".", ",");
      text = text.replace(/[^\d,\+]/g, "");
      if (text[position - 1] === "-" && text.length > 1) {
        if (position - 1 > 0) {
          const token1 = text.substring(0, position - 1);
          const token2 = text.substring(position, text.length);
          text = token1 + token2;
        }
      }
      if (text[position - 1] === "+" && text.length > 1) {
        if (position - 1 > 0) {
          const token1 = text.substring(0, position - 1);
          const token2 = text.substring(position, text.length);
          text = token1 + token2;
        }
      }
      if (text[position - 1] === ",") {
        let counter = charCounter(text, ",");
        if (counter > 1) {
          const token1 = text.substring(0, position - 1);
          const token2 = text.substring(position, text.length);
          text = token1 + token2;
        }
      }
      break;
    case "type-optoacomodativo":
      text = text.replace(".", ",");
      text = text.replace(/[^\d,\-\/]/g, "");
      if (text[position - 1] === "/") {
        let counter = charCounter(text, "/");
        if (counter > 1) {
          const token1 = text.substring(0, position - 1);
          const token2 = text.substring(position, text.length);
          text = token1 + token2;
        }
      } else {
        let tokens = text.split("/");
        tokens[0] = formatField(input, tokens[0], "type-float", false);
        text = tokens[0];
        if (tokens.length > 1) {
          text = tokens[0] + "/" + tokens[1];
        }
      }
      break;
    case "type-optoacomodativo-ada":
      text = text.replace(".", ",");
      text = text.replace(/[^\d,\/\-]/g, ""); // Permite números, coma, barra y negativo

      // El signo negativo solo puede estar al inicio
      if (text.indexOf("-") > 0) {
        text = text.replace(/-/g, ""); // Elimina todos los guiones
        text = "-" + text; // Pone uno solo al inicio
      }

      // Evitar múltiples signos negativos al inicio
      if (text.startsWith("--")) {
        text = text.substring(1);
      }

      // Controlar que solo haya una barra "/"
      if (text[position - 1] === "/") {
        let counter = charCounter(text, "/");
        if (counter > 1) {
          const token1 = text.substring(0, position - 1);
          const token2 = text.substring(position, text.length);
          text = token1 + token2;
        }
      }

      // Controlar que solo haya una coma ","
      if (text[position - 1] === ",") {
        let counter = charCounter(text, ",");
        if (counter > 1) {
          const token1 = text.substring(0, position - 1);
          const token2 = text.substring(position, text.length);
          text = token1 + token2;
        }
      }
      break;
  }

  if (!dontForceUppercase) {
    text = text.toUpperCase();
  }

  return text;
};

export const reformatField = (text, type) => {
  if (text !== "") {
    switch (type) {
      case "type-integer":
        if (text === "-") {
          text = "0";
        } else {
          text = parseInt(text).toString();
        }
        break;
      case "type-positive-integer":
        text = parseInt(text).toString();
        break;
      case "type-integer-min2":
        text = parseInt(text) >= 2 ? parseInt(text).toString() : "";
        break;
      case "type-float":
        if (text === "-" || text === "," || text === "-,") {
          text = "0";
        } else {
          text = parseFloat(text.replace(",", "."))
            .toString()
            .replace(".", ",");
        }
        break;
      case "type-float2":
        if (text === "-" || text === "," || text === "-,") {
          text = "0,00";
        } else {
          text = parseFloat(text.replace(",", "."))
            .toFixed(2)
            .toString()
            .replace(".", ",");
        }
        break;
      case "type-positive-float":
        if (text === ",") {
          text = "0,00";
        } else {
          text = parseFloat(text.replace(",", "."))
            .toFixed(2)
            .toString()
            .replace(".", ",");
        }
        break;
      case "type-floatint":
      case "type-positive-floatint":
        if (text === ",") {
          text = "0,00";
        } else {
          if (text.includes(",")) {
            text = parseFloat(text.replace(",", "."))
              .toFixed(2)
              .toString()
              .replace(".", ",");
          }
        }
        break;
      case "type-optofloat":
        if (text === "+" || text === "," || text === "+,") {
          text = "+0,00";
        } else {
          if (text === "-" || text === "-,") {
            text = "+0,00";
          } else {
            text = parseFloat(text.replace(",", "."))
              .toFixed(2)
              .toString()
              .replace(".", ",");
            if (text[0] !== "-" && text[0] !== "+") {
              text = "+" + text;
            }
          }
        }
        break;
      case "type-positive-optofloat":
        if (text === "," || text === "") {
          text = "+0,00";
        } else {
          const numValue = parseFloat(text.replace(",", "."));

          // Si es inválido o negativo, poner +0,00
          if (isNaN(numValue) || numValue < 0) {
            text = "+0,00";
          } else {
            text = "+" + numValue.toFixed(2).toString().replace(".", ",");
          }
        }
        break;
      case "type-optoacomodativo":
        const tokens = text.split("/");
        if (tokens[0] !== "") {
          if (
            tokens[0] === "-" ||
            tokens[0] === "," ||
            tokens[0] === "-," ||
            tokens[0] === "/"
          ) {
            tokens[0] = "0";
          } else {
            tokens[0] = parseFloat(tokens[0].replace(",", "."))
              .toFixed(2)
              .toString()
              .replace(".", ",");
          }
        } else {
          tokens[0] = "0";
        }
        text = tokens[0] + "/1";
        if (text === "/1") {
          text = "";
        }
        break;
      case "type-optoacomodativo-ada":
        text = text.trim();

        if (text === "") break;

        // Buscar posición de la barra
        let iPosBarra = text.indexOf("/");

        // Si NO hay barra, añadir "/1"
        if (iPosBarra < 0) {
          text = text + "/1";
          iPosBarra = text.indexOf("/");
        }
        // Si la barra está al inicio, añadir "0 " delante
        else if (iPosBarra === 0) {
          text = "0 " + text;
          iPosBarra = text.indexOf("/");
        }

        // Extraer parte antes de la barra (numerador)
        const sNumDelante = text.substring(0, iPosBarra);
        const dbDelante = parseFloat(sNumDelante.replace(",", "."));

        // Validar que sea un número válido
        if (isNaN(dbDelante)) {
          text = ""; // Limpiar si no es válido
          break;
        }

        // Extraer parte después de la barra (denominador)
        const sNumDetras = text.substring(iPosBarra + 1);
        const dbDetras = parseFloat(sNumDetras.replace(",", "."));

        // Validar que sea un número válido
        if (isNaN(dbDetras)) {
          text = ""; // Limpiar si no es válido
          break;
        }

        // Reconstruir el texto formateado (sin redondeo, solo limpieza)
        text = sNumDelante + "/" + sNumDetras;
        break;
    }
  }
  return text;
};

export const convertToNative = (formattedText, type) => {
  if (formattedText !== "") {
    switch (type) {
      case "type-float":
      case "type-float2":
      case "type-positive-float":
        formattedText = formattedText.replace(",", ".");
        break;
      case "type-optofloat":
      case "type-positive-optofloat":
        formattedText = formattedText.replace(",", ".");
        formattedText = formattedText.replace("+", "");
        break;
      case "type-optoacomodativo":
      case "type-optoacomodativo-ada":
        formattedText = formattedText.replace(",", ".");
        formattedText = formattedText.replace("/1", ".");
        break;
    }
  }
  return formattedText;
};

export const checkFormat = (text, type) => {
  let ok = true;
  if (text !== "") {
    switch (type) {
      case "type-email":
        ok = /^\S+@\S+\.\S+$/.test(text);
        break;
      case "type-cp":
        // 5 dígitos: los dos primeros de 01 a 52 (provincia) seguidos de 3 dígitos
        ok = /^(0[1-9]|[1-4][0-9]|5[0-2])[0-9]{3}$/.test(text);
        break;
    }
  }
  return ok;
};

export const onFocusField = (input, type, text) => {
  let newText = text;
  switch (type) {
    case "type-optoacomodativo":
    case "type-optoacomodativo-ada":
      if (text === "") {
        newText = "/1";
      }
      const tokens = newText.split("/");
      recoverCursorPos(input, tokens[0].length);
      break;
  }
  return newText;
};
